import type { BoxProps } from '@shopify/polaris';

// Constants for Box styling
export const BOX_BORDER: BoxProps = {
  borderColor: 'border',
  borderWidth: '025',
};
export const BOX_BORDER_WRAPPER: BoxProps = {
  ...BOX_BORDER,
  borderRadius: '200',
};
export const BOX_BORDER_COLUMN: BoxProps = {
  borderColor: BOX_BORDER['borderColor'],
};
export const BOX_PADDING: BoxProps = {
  padding: '400',
};
export const BOX_PADDING_FOOTER: BoxProps = {
  paddingBlock: '200',
  paddingInline: '400',
};
